import React, { useEffect, useState } from "react";
import ModuleListing from "./ModuleListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/ModuleSlice";
import AddModuleFormWrapper from "../Add/AddModuleFormWrapper";
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import {
  useGetModulePaginationQuery,
  useDeleteModuleMutation,
} from "src/services/ModuleServices";
import { showToast } from "src/utils/showToaster";
import EditModuleFormWrapper from "../Edit/EditModuleFormWrapper";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";

type Props = {};

const ModuleListingWrapper = (props: Props) => {
  const dispatch = useDispatch();

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.module);

  const [isOpenAddFrom, setIsOpenAddForm] = useState(false);
 
  const [isOpenEditFrom, setIsOpenEditForm] = useState(false);
  const [moduleId, setModuleId] = useState("");

  //API

  const [deleteModule] = useDeleteModuleMutation();

  const { data, isLoading, isFetching } = useGetModulePaginationQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["moduleName", "chapterId"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const getActionOptions = (row: any) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setModuleId(row?._id);
          setIsOpenEditForm(true);
        },
        actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.MODULES
      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Module ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result.isConfirmed) {
                deleteModule(row?._id).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.MODULES
      },
    ];
  };
  const columns: columnTypes[] = [
    {
      field: "moduleName",
      headerName: "Module Name",
      flex: "flex-[1_1_0%]",
      extraClasses: "py-2",
      renderCell: (row: any) => <span> {row.moduleName} </span>,
    },
   

    {
      noAuthRequired: true,
      field: "action",
      headerName: "Action",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      <ModuleListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.MODULES,
          actionName: UserModuleActionTypes.LIST,
          columns: columns
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onAddNew={() => setIsOpenAddForm(true)} 
        
      />
      {isOpenAddFrom ? (
        <AddModuleFormWrapper onClose={() => setIsOpenAddForm(false)} />
      ) : null}

      {isOpenEditFrom ? (
        <EditModuleFormWrapper
          moduleId={moduleId}
          onClose={() => setIsOpenEditForm(false)}
        />
      ) : null}
    </div>
  );
};

export default ModuleListingWrapper;
